/* eslint-disable react/jsx-props-no-spreading */
import { useUrlGenerator } from '@folklore/routes';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '../buttons/Button';
import StyledButton from '../buttons/StyledButton';
import Date from '../partials/Date';
import Text from '../typography/Text';
import Title from '../typography/Title';

import styles from '../../../styles/cards/order.module.css';

const propTypes = {
    item: PropTypes.shape({}),
    roles: PropTypes.arrayOf(PropTypes.shape({})),
    className: PropTypes.string,
};

function Order({ item = null, className = null, ...props }) {
    const route = useUrlGenerator();
    const {
        id = null,
        title = null,
        status = null,
        approved = false,
        paid = false,
        created_at: createdAt = null,
        unique_number: uniqueNumber = null,
    } = item || {};

    const url = route('pro.order', { order: id });
    const invoice = route('pro.order.invoice', { order: id });

    return (
        <Button
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            href={!approved && !paid ? url : invoice}
            external={approved || paid}
            {...props}
        >
            <div className={styles.left}>
                <Title className={styles.title} size="small">
                    {title || <FormattedMessage defaultMessage="Event" description="Type label" />}
                </Title>
                <Text className={styles.date}>
                    <Date date={createdAt} />
                </Text>
                <Text className={styles.date}>
                    <FormattedMessage
                        defaultMessage="Facture # : {number}"
                        description="Button label"
                        values={{ number: uniqueNumber }}
                    />
                </Text>
            </div>
            <div className={styles.right}>
                <Text className={styles.status}>{status || null}</Text>
                <StyledButton className={styles.button} size="small">
                    {!approved && !paid ? (
                        <FormattedMessage
                            defaultMessage="Edit your order"
                            description="Button label"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="Download your invoice"
                            description="Button label"
                        />
                    )}
                </StyledButton>
            </div>
        </Button>
    );
}

Order.propTypes = propTypes;

export default Order;
